import React from 'react';

import ProtectedData from 'pages/components/ProtectedData';

import useStyles from './styles';

interface Props {
    href: string;
    className?: string;
}

const Source: React.FC<Props> = ({ href, className }) => {
    const { classes, cx } = useStyles();

    return (
        <span className={cx(classes.container, className)}>
            <span>🔗</span>
            &nbsp;
            <ProtectedData data={href}>
                {({ isProtected, content }) =>
                    isProtected ? (
                        <span className={classes.primary}>{content}</span>
                    ) : (
                        <a href={href} target="_blank" className={classes.primary} rel="noopener noreferrer">
                            {`${content}`.startsWith('http') ? new URL(`${content}`).host : 'Source'}
                        </a>
                    )
                }
            </ProtectedData>
        </span>
    );
};

export default Source;
